export default __webpack_public_path__ + "static/char-v-04-708ac40f7a5b2bebe23149b96758849b.mp4";